import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Grid,
  Chip,
  Collapse,
} from '@mui/material'

const MtlsLayer7Step = ({ formData, setFormData, isComplete, isVisible, stepNumber = 5 }) => {
  return (
    <Collapse in={isVisible}>
      <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip 
              label={isComplete ? "✓" : String(stepNumber)} 
              color={isComplete ? "success" : "primary"} 
              size="small" 
            />
            mTLS and Layer7 Configuration
          </Typography>
          <Divider sx={{ my: 2 }} />
          
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <FormLabel>Mutual auth (mTLS) *</FormLabel>
                <RadioGroup
                  row
                  value={formData.mutualAuth}
                  onChange={(e) => setFormData({ ...formData, mutualAuth: e.target.value })}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>

            {formData.mutualAuth === 'yes' && (
              <>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel>Layer7 *</FormLabel>
                    <RadioGroup
                      row
                      value={formData.layer7}
                      onChange={(e) => setFormData({ ...formData, layer7: e.target.value })}
                    >
                      <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                      <FormControlLabel value="no" control={<Radio />} label="No" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                {formData.layer7 === 'yes' && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Layer7 Endpoint *"
                      value={formData.layer7Endpoint}
                      onChange={(e) => setFormData({ ...formData, layer7Endpoint: e.target.value })}
                    />
                  </Grid>
                )}
              </>
            )}

            {/* On-Prem mTLS specific fields */}
            {formData.isAWS === 'false' && formData.mutualAuth === 'yes' && (
              <>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Public Cert Key Location *"
                    value={formData.onpremAdditionalFields.publicCertKeyLocation}
                    onChange={(e) => setFormData({ ...formData, onpremAdditionalFields: { ...formData.onpremAdditionalFields, publicCertKeyLocation: e.target.value } })}
                    helperText="Location of public certificate key for mTLS"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Private Cert Key Location *"
                    value={formData.onpremAdditionalFields.privateCertKeyLocation}
                    onChange={(e) => setFormData({ ...formData, onpremAdditionalFields: { ...formData.onpremAdditionalFields, privateCertKeyLocation: e.target.value } })}
                    helperText="Location of private certificate key for mTLS"
                  />
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Collapse>
  )
}

export default MtlsLayer7Step
